import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Locale } from "@/Common/Models/Localization/Locale";
import { OntarioPatientEnrollmentModel } from "@/Common/Models/Patient/PatientEnrollment/Ontario/OntarioPatientEnrollmentModel";
import { Person } from "@/Common/Models/Person/Person";

interface IOntarioPatientEnrollmentStatusSectionProps {
    currentEnrollment: OntarioPatientEnrollmentModel;
    onEnrollPatient: () => void;
    onTerminatePatientEnrollment: () => void;
    getPhysician: (contactFacetId: string) => Person;
}

class OntarioPatientEnrollmentStatusSection extends BaseReactComponent<IOntarioPatientEnrollmentStatusSectionProps> {
    public componentWillMount(): void {
        this.setAcceptableLocales([Locale.en, Locale.fr]);
    }

    public render(): JSX.Element {
        const currentEnrollment = this.props.currentEnrollment;

        return (
            <div className="psingle-column wider centered">
                <div className="block separated">
                    <div className="text-right padding-sm-right">
                        {currentEnrollment
                            ? (
                                <a onClick={() => this.props.onTerminatePatientEnrollment()}>
                                    {this.getString("TerminateEnrolmentLabel")}
                                </a>
                            )

                            : (
                                <a onClick={() => this.props.onEnrollPatient()}>
                                    {this.getString("EnrolPatientLabel")}
                                </a>
                            )
                        }
                    </div>
                    <div className="patient-enrollment-item">
                        <div className="table-wrapper">
                            <div className="padding-md-left">
                                <span>{this.getString("EnrolmentStatusLabel")}: </span>
                                <span className="text-bold margin-md-left">
                                    {currentEnrollment
                                        ? `${this.getString("EnrolledToLabel")} ${this.props.getPhysician(currentEnrollment?.EnrolledPhysicianId)?.NameWithPrefix}`
                                        : this.getString("NotEnrolledLabel")
                                    }
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { OntarioPatientEnrollmentStatusSection };
